import {defaultModules, error, notice, Stack, success} from '@pnotify/core';
import * as PNotifyFontAwesome5Fix from '@pnotify/font-awesome5-fix';
import * as PNotifyFontAwesome5 from '@pnotify/font-awesome5';
import * as PNotifyBootstrap4 from '@pnotify/bootstrap4';
import * as PNotifyPaginate from '@pnotify/paginate';
import * as PNotifyMobile from '@pnotify/mobile';
import * as PNotifyAnimate from '@pnotify/animate';

defaultModules.set(PNotifyBootstrap4, {});
defaultModules.set(PNotifyFontAwesome5Fix, {});
defaultModules.set(PNotifyFontAwesome5, {});
defaultModules.set(PNotifyPaginate, {});
defaultModules.set(PNotifyMobile, {});
defaultModules.set(PNotifyAnimate, {
  inClass: 'animate__bounceInLeft',
  outClass: 'animate__bounceOutRight'
});

if (typeof window.stackPaginate === 'undefined') {
  window.stackPaginate = new Stack({
    dir1: 'down',
    dir2: 'left',
    firstpos1: 25,
    firstpos2: 25,
    modal: false,
    context: $('body')[0]
  });
}

export default {
  install(Vue) {
    Vue.prototype.$success = function (opt) {
      let opts = {
        stack: window.stackPaginate,
        destroy: true,
        delay: 1000
      };

      if (opt && opt instanceof Object) {
        opts = Object.assign(opts, opts);
      } else {
        opts = Object.assign(opts, {
          title: "Thông báo",
          text: opt || "Thao tác thực hiện thành công",
        });
      }

      const notice = success(opts);

      notice.on('click', () => {
        notice.close();
      });
    }

    Vue.prototype.$error = function (opt) {

      let opts = {
        stack: window.stackPaginate,
        destroy: true,
        delay: 5000
      };

      if (opt && opt instanceof Object) {
        opts = Object.assign(opts, opts);
      } else {
        opts = Object.assign(opts, {
          title: "Lỗi xảy ra",
          text: opt || "Lỗi không xác định",
        });
      }

      error(opts);
    }

    Vue.prototype.$warning = function (opt) {
      let opts = {
        stack: window.stackPaginate,
        destroy: true,
        delay: 3000
      };

      if (opt && opt instanceof Object) {
        opts = Object.assign(opts, opts);
      } else {
        opts = Object.assign(opts, {
          title: "Cảnh báo",
          text: opt || "Có lỗi xảy ra",
        });
      }

      notice(opts);
    }

    Vue.prototype.$forbidden = function () {
      error({
        stack: window.stackPaginate,
        destroy: true,
        delay: 5000,
        title: "Lỗi xảy ra",
        text: 'Bạn không có quyền truy cập chức năng này.\nVui lòng liên hệ quản lý để được cấp quyền sử dụng chức năng này.',
      });
    }

    Vue.prototype.$cmsBadRequest = function (errorData) {
      if (errorData.response) {
        let status = errorData.response.status;
        if(status === 400){
          error({
            stack: window.stackPaginate,
            destroy: true,
            delay: 5000,
            title: "Lỗi xảy ra",
            text: errorData.response.data,
          });
        }
      }
    }
  }
}